import React from 'react';
import { Image, Type } from '@spotify-internal/encore-creator-web';
import { colorThemeGenerator, ButtonPrimary } from '@spotify-internal/encore-creator-web';
import styled from 'styled-components';
import {
  black,
  white,
  spacer16,
  spacer20,
  spacer48,
  spacer56,
  screenMdMin,
  screenSmMin,
} from '@spotify-internal/encore-foundation';

export function GimletAcademy() {
  return (
    <GimletAcademyWrapper>
      <GimletAcademyContainer>
        <Type as="h2" variant="heading2" style={{ marginBottom: spacer20 }}>
          Want to learn from the best?
        </Type>
        <GimletAcademyImage
          src="/images/landing_page/gimlet-academy-cover.png"
          alt="Gimlet Academy cover"
        />
        <GimeletAcademySubHeader>
          In this podcast, Gimlet cofounder Alex Blumberg provides advanced tips — on topics like
          booking interviews, recording ‘good tape,’ and editing compelling stories — to help
          podcasters on Spotify take their shows to the next level.
        </GimeletAcademySubHeader>
        <ButtonPrimary
          href="https://open.spotify.com/show/7hhEbl4DOMheWRunCUAla6"
          target="_blank"
          rel="noopener noreferrer"
          theme={{
            ...colorThemeGenerator({
              primaryColor: white,
            }),
          }}
        >
          Listen Now
        </ButtonPrimary>
      </GimletAcademyContainer>
    </GimletAcademyWrapper>
  );
}

const GimletAcademyWrapper = styled.div`
  background-color: ${black};
`;

const GimletAcademyContainer = styled.div`
  max-width: 732px;
  margin: auto;
  text-align: center;
  padding: 100px ${spacer16} 124px;
  @media (max-width: ${screenMdMin}) {
    padding-top: ${spacer56};
  }
`;

const GimletAcademyImage = styled(Image).attrs({})`
  max-width: 520px;
  width: 100%;
  margin-bottom: ${spacer48};
`;

const GimeletAcademySubHeader = styled(Type).attrs({
  forwardedAs: 'p',
  variant: Type.body1,
})`
  margin-bottom: 28px;
  @media (max-width: ${screenSmMin}) {
    text-align: left;
  }
`;
